module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0032.jpg?v=4c5afa54";